import { ModuleColorTheme } from '~/lib';

export const defaultColorTheme: ModuleColorTheme = {
    foregroundColor: '#231f20',
    gradientHighlight: false,
    hasChildren: false,
    highlightColor: '#f68a20',
    mainColor: '#f6f4f1',
    name: 'Beige - Light Orange Accent',
    secondaryColor: '#231f20',
    secondaryColorOpacity: '6',
    sortOrder: 1,
    textColor: '',
    url: '',
    id: '',
};
